import { render, staticRenderFns } from "./RefinementForm.vue?vue&type=template&id=0a77f16e&scoped=true"
import script from "./RefinementForm.vue?vue&type=script&lang=js"
export * from "./RefinementForm.vue?vue&type=script&lang=js"
import style0 from "./RefinementForm.vue?vue&type=style&index=0&id=0a77f16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.8.1_vue-template-compiler@2.6.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a77f16e",
  null
  
)

export default component.exports